import { LogLevel } from 'angular-auth-oidc-client';

export const environment = {
  production: false,
  apiUrl: 'https://main.api.app.dev.dx-tract.de',
  apiBaseUrl: 'https://main.api.app.dev.dx-tract.de/api',
  isLocalDev: false,
  auth: {
    enabled: true,
    authority: 'https://cognito-idp.eu-west-1.amazonaws.com/eu-west-1_6P4F8OyCg',
    redirectUrl: 'https://main.app.dev.dx-tract.de/auth/callback',
    clientId: '2jikbn7hbvqf70h2f1ng2orhvh',
    scope: 'email openid phone profile',
    responseType: 'code',
    postLogoutRedirectUri: 'https://main.app.dev.dx-tract.de',
    silentRenew: true,
    useRefreshToken: true,
    maxIdTokenIatOffsetAllowedInSeconds: 1000,
    customParamsAuthRequest: {},
    customParamsRefreshTokenRequest: {},
    customParamsEndSessionRequest: {},
    customParamsCodeRequest: {},
    disableIdTokenValidation: false,
    disableRefreshIdTokenAuthTimeValidation: false,
    ignoreNonceAfterRefresh: false,
    allowUnsafeReuseRefreshToken: false,
    autoUserInfo: false,
    renewTimeBeforeTokenExpiresInSeconds: 30,
    secureRoutes: ['https://main.api.app.dev.dx-tract.de/api'],
    wellKnownEndpointUrl:
      'https://cognito-idp.eu-west-1.amazonaws.com/eu-west-1_6P4F8OyCg/.well-known/openid-configuration',
    logLevel: LogLevel.None,
  },
};
